/* Info Component in MoodboardsPage */
import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import styles from "../../styles/Callsheets.module.css";

const InfoCreate = () => {
  return (
    <div>
        <Row className='mb-3'>
            <Col className={`text-center px-3 pt-1 ${styles.SubTitle6 }`} md={{span: 10, offset: 1 }}>
            <h5 className={`text-center ${styles.Red }`} >INFO</h5>
              <p className='pt-2'>Add as many Moodboards for a Scene, Character or Location as needed. </p>
              <p className='pt-2'>Moodboard may be for one element or any mixture
                of the three.</p>
              <p className='pt-2'>
             Create Moodboards for other themes by using the Title only. 
            </p>
            </Col>
        </Row>
    </div>
  )
}

export default InfoCreate